var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container owl-theme" }, [
    _c("div", { staticClass: "alignBox owlArea" }, [
      _c(
        "div",
        {
          staticClass:
            "titleHeading d-flex justify-content-between align-items-center",
        },
        [
          _c("div", { staticClass: "headingTxt" }, [
            _vm._v(_vm._s(_vm.shop.productTree.product.dn)),
          ]),
          _vm._v(" "),
          _vm._m(0),
        ]
      ),
      _vm._v(" "),
      _c(
        "ul",
        { ref: "prodCarousel", staticClass: "prodCarousel" },
        _vm._l(_vm.availableCategories, function (cat, i) {
          return _c("li", { key: i, staticClass: "menuItem" }, [
            _c(
              "div",
              { staticClass: "owlItemBox" },
              [
                _c(
                  "a",
                  {
                    attrs: {
                      href: _vm.shop.ShopId + "/carte/" + cat.tid,
                      title: cat.product.dn,
                    },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "img-container prodImg d-flex justify-content-center align-items-center",
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: _vm.UrlService.imagePath(
                              cat.product.ShopId,
                              cat.product.imt
                            ),
                            alt: cat.product.dn,
                          },
                          on: {
                            error: function ($event) {
                              $event.target.src = "dist/assets/no-img.png"
                            },
                          },
                        }),
                      ]
                    ),
                  ]
                ),
                _vm._v(" "),
                cat.product.Promo
                  ? _c("promo-grid-view", { attrs: { chevrons: true } })
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "bottomProd d-flex flex-column justify-content-between align-items-center",
                  },
                  [
                    _c("div", { staticClass: "titlePrice" }, [
                      _c("span", { staticClass: "title" }, [
                        _vm._v(_vm._s(cat.product.dn)),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "ifPrice" }, [
                        _vm._v(
                          _vm._s(_vm.ShopService.prix(cat.product.dp, " "))
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "descBloc" }, [
                      _c("span", {
                        staticClass: "desc",
                        domProps: { innerHTML: _vm._s(cat.product.dd) },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "linkOwl" }, [
                      _c(
                        "a",
                        {
                          attrs: {
                            href: _vm.shop.ShopId + "/carte/" + cat.tid,
                            title: cat.product.dn,
                          },
                        },
                        [
                          _vm.shop.canOrder
                            ? _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.shop.info.labels.PassezCommande ||
                                      "Passez Commande"
                                  )
                                ),
                              ])
                            : _c("span", [_vm._v("Plus de détails")]),
                        ]
                      ),
                    ]),
                  ]
                ),
              ],
              1
            ),
          ])
        }),
        0
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "headingIcon" }, [
      _c("i", { staticClass: "icon-eatselfapp_menu-card" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }